let id = 0;

export function autoIncrement(): number {
  return ++id;
}
